export const errorPageContent = {
  emojiTitle: 'Oops! 😅',
  heading: 'Page Not Found',
  description:
    "The page you're looking for doesn't exist or has been moved. Don't worry though - you can easily find what you need!",
  primaryActionLabel: 'Go Home',
  primaryActionPath: '/',
  secondaryActionLabel: 'Contact Us',
  secondaryActionPath: '/contact',
  footerNote:
    "If you believe this is an error, please contact us and we'll help you find what you're looking for.",
};
